import { useEffect } from 'react';

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} · numbercrunch.ai` : 'numbercrunch.ai — Build your financial model. Keep the Excel.';
    if (description) document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    const privatePage = /^\/(app|admin|login|signup|reset-password|auth)(\/|$)/.test(window.location.pathname);
    document.querySelector('meta[name="robots"]')?.setAttribute('content', privatePage ? 'noindex,nofollow' : 'index,follow');
  }, [title, description]);
}

export function Section({ eyebrow, title, lede, children, className = '', id, testId }) {
  return <section id={id} className={`container-x py-16 md:py-24 ${className}`} data-testid={testId}>
    {(eyebrow || title) && <div className="max-w-2xl">
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      {title && <h2 className="h2">{title}</h2>}
      {lede && <p className="lede mt-4">{lede}</p>}
    </div>}
    <div className={title ? 'mt-10' : ''}>{children}</div>
  </section>;
}

export function Prose({ children }) {
  return <div className="prose-nc max-w-3xl space-y-4 text-base leading-relaxed text-foreground/90 [&_h2]:h2 [&_h2]:mt-10 [&_h3]:h3 [&_h3]:mt-8 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-1 [&_p]:text-muted-foreground [&_li]:text-muted-foreground [&_a]:underline [&_strong]:text-foreground">{children}</div>;
}

export function PageHeader({ eyebrow, title, lede, children }) {
  return <div className="border-b border-border bg-card"><div className="container-x py-14 md:py-20">
    <div className="max-w-3xl">{eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}<h1 className="h1 !text-3xl sm:!text-4xl lg:!text-5xl">{title}</h1>{lede && <p className="lede mt-4">{lede}</p>}{children}</div>
  </div></div>;
}
